import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Sparkles } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data: user } = await api.post("/auth/google", { session_id });
        setUser(user);
        // strip the hash, send to feed
        window.history.replaceState({}, "", "/feed");
        nav("/feed", { replace: true, state: { user } });
      } catch (e) {
        setErr(formatErr(e));
        setTimeout(()=>nav("/login", { replace: true }), 1500);
      }
    })();
  }, [location.hash, nav, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Sparkles className="mx-auto mb-3 text-[#0057FF]" size={22}/>
        <p className="font-heading text-2xl">Signing you in…</p>
        {err && <p className="text-sm text-[#B84B4B] mt-3" data-testid="auth-callback-error">{err}</p>}
      </div>
    </div>
  );
}
